var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldForward5Seconds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.43 6.98c-.32.26-.37.73-.11 1.05 1.13 1.4 1.76 3.06 1.82 4.8.16 4.48-3.36 8.26-7.85 8.41-4.49.16-8.26-3.36-8.42-7.84-.16-4.48 3.36-8.26 7.85-8.41.57-.02 1.17.03 1.82.16.04.01.08 0 .12 0 .1.05.22.08.33.08a.7.7 0 0 0 .47-.17c.32-.26.37-.73.12-1.05L12.6 1.54a.748.748 0 0 0-1.05-.12c-.32.26-.37.73-.12 1.05l.83 1.03c-.19-.01-.39-.02-.58-.01-5.31.18-9.48 4.66-9.29 9.97.19 5.31 4.66 9.48 9.97 9.29 5.31-.19 9.48-4.66 9.29-9.97a9.629 9.629 0 0 0-2.17-5.69.747.747 0 0 0-1.05-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.09 16.92c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.29a.781.781 0 0 0 0-1.56h-2.29c-.24 0-.47-.12-.61-.31a.746.746 0 0 1-.1-.68l.76-2.29c.1-.31.39-.51.71-.51h3.06c.41 0 .75.34.75.75s-.34.75-.75.75h-2.52l-.26.79h1.25a2.279 2.279 0 1 1 0 4.56h-2.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldForward5Seconds);
export default __webpack_public_path__ + "static/media/vuesax-bold-forward-5-seconds.0a8660a8e20a0a0815ad5625ba9275d2.svg";
export { ForwardRef as ReactComponent };